import LatestPostsWidget from "@/components/LatestPostsWidget";
import EventsCalendarWidget from "@/components/EventsCalendarWidget";
import AdBlock from "@/components/AdBlock";

/**
 * Variants:
 * - "default"   → Latest Posts + Calendar (used on inner pages without their own latest list)
 * - "with-ads"  → 2 Ads + Latest Posts + Calendar (used on Featured/Recent/Latest detail pages)
 * - "ads-events" → 2 Ads + Calendar ONLY (used on home, where Latest Posts moved into the main column)
 */
export default function Sidebar({ variant = "default" }) {
    return (
        <aside className="space-y-10" data-testid="sidebar">
            {(variant === "with-ads" || variant === "ads-events") && (
                <div className="grid grid-cols-2 gap-4" data-testid="sidebar-ads">
                    <AdBlock />
                    <AdBlock />
                </div>
            )}
            {variant !== "ads-events" && <LatestPostsWidget />}
            <EventsCalendarWidget />
        </aside>
    );
}
